<template>
  <section class="services-section text-center">
    <div class="container">
      <h2>Specialized Services</h2>
      <div class="row">
        <div class="col-md-4" v-for="(service, index) in services" :key="index">
          <b-card :title="service.title">
            <p>{{ service.description }}</p>
            <b-button variant="primary">Learn More</b-button>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        { title: 'Emergency Control', description: 'Expert handling of emergency situations.' },
        { title: 'Fire Training', description: 'Specialized fire control training.' },
        { title: 'Response Audits', description: 'Comprehensive response planning.' }
      ]
    };
  }
};
</script>

<style scoped>
.services-section {
  padding: 60px 0;
  background-color: #f1f1f1;
}
</style>
